export class MdDataTableRenderer {
  constructor() {
    'ngInject';
    this.restrict = 'E';
  }

  templateUrl($element, $attrs) {
    return $attrs.templateUrl ? $attrs.templateUrl : 'mdDataTableRenderer.html';
  }
}
